export default "__VITE_ASSET__fdc81a5d__"